import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {OneTimePermissionRequestContainerModel} from '../../../../../models/aggregates/permissions';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';

// /core2/tnt/dm/applet/perm/one-time-perm-request-histories/backoffice-ep

@Injectable({
  providedIn: 'root'
})
export class OneTimePermRequestHistoryService extends BaseApiTemplateService<OneTimePermissionRequestContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-histories/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-histories/backoffice-ep';
    this.httpClient = http;
  }


  // /core2/tnt/dm/applet/perm/one-time-perm-request-histories/multi/delete-queues/backoffice-ep
  manageApproval(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-histories/multi/delete-queues/backoffice-ep';
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          this.apiUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

  manageApprovalHdr(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>>
  {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-histories/delete-queues/hdr/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}


